import { Form } from 'react-bootstrap';
import { SearchBoxProps } from './searchBoxProps';

const SearchBox = (props: SearchBoxProps) => {
    const {
        containerClassName = '', // default props
        className = '', // default props
    } = props;

    return (
        <Form id='dash-search' role='search' aria-label='Search dashboard' className={containerClassName}>
            <Form.Group className={className}>
                <Form.Text id='search-icon'>
                    <i className='icon-search' aria-hidden='true' role='presentation' />
                </Form.Text>
                <Form.Control
                    id='dash-search-input'
                    type='text'
                    placeholder='Search'
                    aria-label='Search'
                    aria-describedby='search-icon'
                />
            </Form.Group>
        </Form>
    );
};

export default SearchBox;
